import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface EndUserLocationChartProps {
        value: number,
        target: number
}

const EndUserLocationChart = ({ value, target }: EndUserLocationChartProps) => {
        // Calculate percentage
        const percentage = Math.min(Math.max(value, 0), target);

        // Data layout: [Progress filled, Remaining portion]
        const data = [
                { name: 'Progress', value: percentage },
                { name: 'Remaining', value: target - percentage },
        ];

        // Define colors for filled vs empty tracks
        const COLORS = ['#4F46E5', '#E5E7EB'];

        return (
                <div style={{ width: '100%', height: '70%', position: 'relative', textAlign: 'center' }}>
                        <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                        <Pie
                                                data={data}
                                                cx="50%"         // Center horizontally
                                                cy="100%"        // Anchor to bottom to create a clean semi-circle layout
                                                startAngle={180} // Starts from left side
                                                endAngle={0}     // Ends on right side
                                                innerRadius={80} // Adjust width thickness
                                                outerRadius={110}
                                                dataKey="value"
                                                stroke="none"
                                        >
                                                {data.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                ))}
                                        </Pie>
                                </PieChart>
                        </ResponsiveContainer>

                        {/* Absolute center positioning for text labels */}
                        <div style={{
                                position: 'absolute',
                                bottom: '10px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                        }}>
                                <h2 style={{ margin: 0, fontSize: '2rem', fontWeight: 'bold' }}>{percentage}%</h2>
                                <p style={{ margin: 0, color: '#6B7280', fontSize: '0.875rem' }}>Online</p>
                        </div>
                </div>
        );
};

export default EndUserLocationChart;
